import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import useTranslation from 'next-translate/useTranslation'

export const Specifications = ({ specifications }) => {
	const { t } = useTranslation('common')

	return (
		<section className='vehicle-part-specifications'>
			<h3 className='vehicle-part-specifications__title'>{t('specifikacije')}</h3>

			{specifications.map(spec => (
				<div key={spec.id} className='vehicle-part-specifications__item'>
					<span className='vehicle-part-specifications-item-name'>{t(`${spec.name}`)}</span>
					<span className='vehicle-part-specifications-item-value'>{spec.value}</span>
				</div>
			))}
		</section>
	)
}

Specifications.propTypes = {
	specifications: PropTypes.arrayOf(PropTypes.shape({
		name: PropTypes.string.isRequired,
		value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
		id: PropTypes.number.isRequired,
	})).isRequired,
}
